import { render } from "./Tips.vue?vue&type=template&id=20d730d6&scoped=true"
import script from "./Tips.vue?vue&type=script&lang=js"
export * from "./Tips.vue?vue&type=script&lang=js"

import "./Tips.vue?vue&type=style&index=0&id=20d730d6&scoped=true&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20d730d6"]])

export default __exports__